<template>
  <div class="article-search-container">
    <a-input-search
      placeholder="请输入关键词..."
      style="width:250px"
      allow-clear
      @search="value => $emit('onSearch', value)"
    />
    <a-select
      style="width:200px"
      class="select-container"
      placeholder="请选择公司"
      @change="value => $emit('onChangeCompany', value)"
    >
      <a-select-option
        v-for="item in companyData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      新增调研问卷
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      companyData: [{id: 0, name: '所有公司'}],
    };
  },
  mounted(){
    // 获取企业
    this.getCompanyData('/company/getCompanyList');

  },
  methods: {
    // 获取企业
    async getCompanyData(url) {
      let result = await this.$http.post(url);
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item)=>{return {name: item.team_name?item.team_name:item.companyInfo.qichacha_name, ...item};});
        this.companyData = [...this.companyData, ...data];
      }
    },
  },
};
</script>
<style lang="scss">
.article-search-container {
  min-height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 20px;
    margin-right: 20px;
  }
  .ant-select-selection {
     border-radius: 20px;
  }
  .ant-btn-round {
  font-size: 12px;
  height: 30px;
  padding: 0 17px;
  border-radius: 15px;
  margin-left: 20px;
}
  .select-container{
    margin:0 5px;
  }
}
</style>
